<template>
  <div>
    <div class="wrapper">
      <b-row class="mt-2 mb-2">
        <b-col>
          <b-button class="pull-right" variant="primary" v-b-modal.modal-1>Gebruiker aanmaken</b-button>
        </b-col>
      </b-row>
      <div class="animated fadeIn">
        <resource-index header="Admin gebruikers" endpoint="users" show-route="users.view" />
      </div>
    </div>
    <b-modal id="modal-1" title="Admin gebruiker aanmaken" hide-footer>
      <b-form @submit.prevent="createUser">
        <b-form-group label="Naam">
          <b-form-input type="text" required v-model="item.name"></b-form-input>
        </b-form-group>
        <b-form-group label="E-mailadres">
          <b-form-input type="text" required v-model="item.email"></b-form-input>
        </b-form-group>
        <b-form-group label="Telefoonnummer">
          <b-form-input type="text" required v-model="item.phonenumber"></b-form-input>
        </b-form-group>
        <b-button class="pull-left" variant="danger" @click="closeModal">Annuleer</b-button>
        <b-button type="submit" class="pull-right" variant="success">Maak gebruiker aan</b-button>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import ResourceIndex from '../../components/ResourceIndex';
import {addData} from "@/api";

export default {
  name: 'users',
  components: { ResourceIndex },
  data() {
    return {
      item: {
        name: null,
        phonenumber: null,
        email: null,
      }
    }
  },
  methods: {
    async createUser() {
      let request = await addData('users', {
        name: this.item.name,
        email: this.item.email,
        phonenumber: this.item.phonenumber,
      }).then(response => response);

      if (request.status === 201) {
        return this.$router.push({ name: 'users.view', params: {id: request.data.data.id}});
      }
    },
    async closeModal() {
      this.$bvModal.hide('modal-1');
      this.item = {
        username: null,
        type: null,
        accountId: null,
        contactId: null,
        invitation: 0,
      };
    }
  }
}

</script>
